const APP_KEY = process.env.REACT_APP_STORAGE_KEY

const PREVIOUS_ROUTE_STORAGE_KEY = `${APP_KEY}_previous_route`

export const getPreviousRoute = () => {
  return sessionStorage?.getItem(PREVIOUS_ROUTE_STORAGE_KEY) || undefined
}

export const setPreviousRoute = (route?: string): void => {
  if (route) {
    sessionStorage?.setItem(PREVIOUS_ROUTE_STORAGE_KEY, route)
    return
  }

  sessionStorage?.removeItem(PREVIOUS_ROUTE_STORAGE_KEY)
}
